import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'
import clsx from 'clsx'

function cn(...inputs) {
  return twMerge(clsx(inputs))
}

let clickable = true

const debouncedFC = (click) => {
  if (clickable) {
    click()
    clickable = false
    setTimeout(() => {
      clickable = true
    }, 3000)
  }
}

const notify = (message, type = 'success') => {
  const showToast = toast[type]
  if (typeof showToast === 'function') {
    debouncedFC(() =>
      showToast(message, {
        duration: 1500,
      })
    )
  } else {
    console.warn(`Invalid toast type: ${type}`)
  }
}

function formatBytes(bytes, opts = {}) {
  const { decimals = 0, sizeType = 'normal' } = opts

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const accurateSizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB']
  if (bytes === 0) return '0 Byte'
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${(bytes / 1024 ** i).toFixed(decimals)} ${sizeType === 'accurate' ? accurateSizes[i] ?? 'Bytes' : sizes[i] ?? 'Bytes'}`
}

export { cn, notify, formatBytes }
